export const new_GroupButton = "Kec";
export const delete_GroupButton = "Lec";
export const moveAndDelete_GroupButton = "Mec";
export const neverBlockGroupOrDL_Button = "Nec";
export const respond_GroupButton = "Oec";
export const respond_GroupOverflow_Button = "Pec";
export const tags_GroupButton = "Qec";
export const tags_GroupOverflow_Button = "Rec";
export const send_GroupButton = "Sec";
export const send_GroupOverflow_Button = "Tec";
export const sync_GroupButton = "Uec";
export const sync_GroupOverflow_Button = "Vec";
export const offline_GroupButton = "Wec";
export const offline_GroupOverflow_Button = "Xec";
export const download_GroupButton = "Yec";
export const download_GroupOverflow_Button = "Zec";
export const quickSteps_GroupButton = "_ec";
export const move_GroupButton = "$ec";
export const archivePolicy_menuGroupLabel = "afc";
export const retentionPolicy_menuGroupLabel = "bfc";
export const find_GroupButton = "cfc";
export const speech_GroupButton = "dfc";
export const addIns_GroupButton = "efc";
export const teams_GroupButton = "ffc";
export const insights_GroupButton = "gfc";
export const protection_GroupButton = "hfc";
export const immersiveReader_GroupButton = "ifc";
export const print_GroupButton = "jfc";
export const undo_GroupButton = "kfc";
export const toggleLeftPane_Group = "lfc";
export const clipboard_Group = "mfc";
export const names_Group = "nfc";
export const include_Group = "ofc";
export const voice_Group = "pfc";
export const encrypt_Group = "qfc";
export const save_Group = "rfc";
export const sensitivity_Group = "sfc";
export const basicText_Group = "tfc";
export const paragraph_Group = "ufc";
export const tables_Group = "vfc";
export const links_Group = "wfc";
export const illustrations_Group = "xfc";
export const notes_GroupNew = "yfc";
export const notes_GroupEdit = "zfc";
export const notes_GroupView = "Afc";
export const table_GroupMerge = "Bfc";
export const table_GroupInsert = "Cfc";
export const table_GroupStructure = "Dfc";
export const table_GroupAlignment = "Efc";
export const table_GroupTableStyles = "Ffc";
export const viewSettings_Group = "Gfc";
export const viewMessages_Group = "Hfc";
export const viewLayout_Group = "Ifc";
export const playMyEmails_Group = "Jfc";
export const tools_Group = "Kfc";
export const tags_Group = "Lfc";
export const actions_Group = "Mfc";
export const findTime_GroupButton = "Nfc";
export const insert_Group = "Ofc";
export const options_Group = "Pfc";
export const proofing_Group = "Qfc";
export const loop_Group = "Rfc";
export const format_Group = "Sfc";
export default {new_GroupButton,delete_GroupButton,moveAndDelete_GroupButton,neverBlockGroupOrDL_Button,respond_GroupButton,respond_GroupOverflow_Button,tags_GroupButton,tags_GroupOverflow_Button,send_GroupButton,send_GroupOverflow_Button,sync_GroupButton,sync_GroupOverflow_Button,offline_GroupButton,offline_GroupOverflow_Button,download_GroupButton,download_GroupOverflow_Button,quickSteps_GroupButton,move_GroupButton,archivePolicy_menuGroupLabel,retentionPolicy_menuGroupLabel,find_GroupButton,speech_GroupButton,addIns_GroupButton,teams_GroupButton,insights_GroupButton,protection_GroupButton,immersiveReader_GroupButton,print_GroupButton,undo_GroupButton,toggleLeftPane_Group,clipboard_Group,names_Group,include_Group,voice_Group,encrypt_Group,save_Group,sensitivity_Group,basicText_Group,paragraph_Group,tables_Group,links_Group,illustrations_Group,notes_GroupNew,notes_GroupEdit,notes_GroupView,table_GroupMerge,table_GroupInsert,table_GroupStructure,table_GroupAlignment,table_GroupTableStyles,viewSettings_Group,viewMessages_Group,viewLayout_Group,playMyEmails_Group,tools_Group,tags_Group,actions_Group,findTime_GroupButton,insert_Group,options_Group,proofing_Group,loop_Group,format_Group};